/*
 * @Author: Yue Hu(yuhu@nvidia.com)
 * @Date: 2024-11-16 15:25:44
 * @LastEditors: Yue Hu(yuhu@nvidia.com)
 * @LastEditTime: 2024-11-21 23:28:44
 * @FilePath: /mooctest.com/src/api/user.js
 */
// 用户相关api
import request from "../utils/request";
import { t } from "../i18n/i18n";
// 登录
export function login(email, password) {
  return request({
    url: "/test/login",
    method: "POST",
    data: {
      email,
      password,
    },
  });
} // 注册
export function register(username, email, password) {
  return request({
    url: "/test/register",
    method: "POST",
    data: {
      name: username,
      email,
      password,
    },
  });
}

// 获取个人信息
export function userInfoGet(uid) {
  return request({
    url: `/user/info/${uid}`,
    method: "GET",
  });
}

// 编辑个人信息
export function userInfoEdit(fd) {
  return request({
    url: "/user/edit",
    method: "POST",
    data: fd,
    otherOptions: {
      showLoading: true,
      loadingSetting: {
        text: t("common.saving"),
      },
    },
  });
}

// 修改密码
export function userPwdChange(password, oldPassword, id) {
  return request({
    url: "/user/pwd",
    method: "PUT",
    data: {
      password,
      oldPassword,
      id,
    },
  });
}

// 登出
export function logout() {
  return request({
    url: "/test/logout",
    method: "GET",
  });
}
